import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    type: 'fixed',
    technique: 'dryland',
    plantingDate: undefined,
    applicationDate: undefined,
    phone: undefined,
    distributor: undefined,
    estimatedApplicationDate: undefined,
    hybrid: undefined,
    productName: undefined,
    managementZones: [],
    managementZoneFiles: [],
    environment: undefined,
    companyName: undefined,
    nitrogenSource: undefined,
    cropMonitoring: {},
};

export default createReducer(initial, {
    [actions.setType]: (state, action) => {
        return { ...state, type: action.payload, managementZones: [] };
    },
    [actions.setPlantingDate]: (state, action) => {
        return { ...state, plantingDate: action.payload };
    },
    [actions.setApplicationDate]: (state, action) => {
        return { ...state, applicationDate: action.payload };
    },
    [actions.setCompanyName]: (state, action) => {
        return { ...state, companyName: action.payload };
    },
    [actions.setPhone]: (state, action) => {
        return { ...state, phone: action.payload };
    },
    [actions.setEstimatedApplicationDate]: (state, action) => {
        return { ...state, estimatedApplicationDate: action.payload };
    },
    [actions.setSelectedHybrid]: (state, action) => {
        return { ...state, hybrid: action.payload };
    },
    [actions.setProductName]: (state, action) => {
        return { ...state, productName: action.payload };
    },

    [actions.setNitrogenSource]: (state, action) => {
        return { ...state, nitrogenSource: action.payload };
    },
    [actions.setManagementZone]: (state, action) => {
        const filteredManagementZones = state.managementZones.filter((mz) => mz.id != action.payload.id);
        return { ...state, managementZones: [...filteredManagementZones, action.payload].sort((a, b) => a.id - b.id) };
    },
    [actions.addManagementZone]: (state, action) => {
        return { ...state, managementZones: [...state.managementZones, action.payload] };
    },
    [actions.setNewManagementZoneFiles]: (state, action) => {
        return { ...state, managementZoneFiles: action.payload };
    },
    [actions.setNitrogenRecommendation]: (state, action) => {
        return {
            ...state,
            type: action.payload.type,
            id: action.payload.id,
            managementZones: action.payload.managementZones,
            plantingDate: action.payload.plantingDate,
            applicationDate: action.payload.applicationDate,
            managementZoneFiles: action.payload.managementZoneFiles,
            estimatedApplicationDate: action.payload.estimatedApplicationDate,
            hybrid: action.payload.hybrid,
            nitrogenSource: action.payload.nitrogenSource,
            phone: action.payload.phone,
            distributor: action.payload.distributor,
            companyName: action.payload.companyName,
            productName: action.payload.productName,
            technique: action.payload.technique,
        };
    },
    [actions.removeManagementZone]: (state, action) => {
        const filteredManagementZones = state.managementZones.filter((mz) => mz.id != action.payload.id);

        return { ...state, managementZones: [...filteredManagementZones] };
    },
    [actions.removeAll]: (state) => {
        return { ...initial };
    },
    [actions.setCropMonitoring]: (state, action) => {
        return { ...state, cropMonitoring: action.payload };
    },
});
